export const REMOTE_CONFIG_KEY_IS_APP_REVIEW = "is_app_review";
export const REMOTE_CONFIG_KEY_IS_NOTIFICATION_TASK_ENABLED =
  "task_open_notification_display";
export const REMOTE_CONFIG_KEY_MEMBER_LIFETIME_AND_WEEKLY_PRODUCT =
  "member_lifetime_and_weekly_product";
/** App 最低 buildNumber；JSON `{ "ios": number, "android": number }` */
export const REMOTE_CONFIG_KEY_APP_MINIMUM_BUILD_NUMBER =
  "app_minimum_build_number";
/** 是否允许关闭 App 升级引导弹窗；false 时隐藏 Maybe Later 且 Update now 不关闭弹窗 */
export const REMOTE_CONFIG_KEY_CAN_CLOSE_UPGRADE_MODAL =
  "can_close_upgrade_modal";
/** Plaid 门控模式：`free_trial`（默认）| `paywall_first` */
export const REMOTE_CONFIG_KEY_PLAID_GATE_MODE = "plaid_gate_mode";
/** Plaid 免费试链天数（文案展示；权威天数在后端 Nacos） */
export const REMOTE_CONFIG_KEY_PLAID_FREE_TRIAL_DAYS = "plaid_free_trial_days";
